/** A countdown is usable only after an authoritative HELD receipt. */
export function holdDeadline(data, receivedAt = Date.now()) {
  if (!data || data.state !== 'HELD' || !data.hold_id) return null
  const expiry = Date.parse(data.expires_at)
  const remaining = Number(data.remaining_seconds)
  if (!Number.isFinite(expiry) || !Number.isFinite(remaining) || remaining <= 0) return null
  const duration = Math.min(expiry - receivedAt, remaining * 1000)
  return duration > 0 ? receivedAt + duration : null
}

export function holdRemaining(deadline, now = Date.now()) {
  return deadline ? Math.max(0, Math.ceil((deadline - now) / 1000)) : 0
}
